import React, { useEffect, useState } from 'react';

/**
 * YorstrulyKasim: Kasım 2026 toplantısı: satış, Meta, yapılanlar, yeni setler, Kasım kampanyası, e-posta, stok.
 * Route: /r/yorstruly-kasim (sidebar YOK, tam ekran slayt, 14 slayt 16:9, Türkçe).
 * Yeniden üretmek için: node src/pages/yorstruly-kasim/build.js (veri: fetch_meta.js, fetch_shopify.js, fetch_shopify_api.js, data.py) (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~115KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function YorstrulyKasim() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./yorstrulyKasimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Yorstruly · Kasım 2026 Çalışma Durumu"
      srcDoc={html}
      style={fill}
    />
  );
}
